import { useEffect } from 'react';
import { useOfflineQueue } from '@/hooks/useOfflineQueue';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { Loader2, Wifi, WifiOff } from 'lucide-react';
import { Button } from './ui/button';
import { Card } from './ui/card';

/**
 * Composant pour afficher l'état de synchronisation offline
 */
export const OfflineSync = () => {
  const { isOnline, isOffline } = useNetworkStatus();
  const { queueCount = 0, isSyncing = false, syncQueue } = useOfflineQueue();

  // Afficher uniquement si offline ou si des actions en attente
  if (isOnline && queueCount === 0) {
    return null;
  }

  return (
    <Card className="fixed bottom-20 right-4 z-50 p-4 shadow-lg max-w-xs">
      <div className="flex items-start gap-3">
        {isOffline ? (
          <WifiOff className="h-5 w-5 text-destructive flex-shrink-0 mt-0.5" />
        ) : (
          <Wifi className="h-5 w-5 text-success flex-shrink-0 mt-0.5" />
        )}
        
        <div className="flex-1 space-y-2">
          <div>
            <p className="font-medium text-sm">
              {isOffline ? 'Mode hors ligne' : 'En ligne'}
            </p>
            {queueCount > 0 && (
              <p className="text-xs text-muted-foreground">
                {queueCount} action{queueCount > 1 ? 's' : ''} en attente
              </p>
            )}
          </div>

          {isOnline && queueCount > 0 && (
            <Button
              size="sm"
              variant="outline"
              onClick={syncQueue}
              disabled={isSyncing}
              className="w-full"
            >
              {isSyncing ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Synchronisation...
                </>
              ) : (
                'Synchroniser maintenant'
              )}
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};
